export default __webpack_public_path__ + "static/media/loading-wheel.a1a99674.gif";